import { createSelector } from 'reselect';

import { RootState } from '@client/redux/types';

export const categorySubLinesSelector = (state: RootState) =>
    state.myloungeMetadata.categorySubline || {};

export const makeGetCampaignCategories = () =>
    createSelector(
        categorySubLinesSelector,
        (state: RootState, campaignId: string) => campaignId,
        (categorySubLines, campaignId) => categorySubLines[campaignId] || [],
    );
